export default __webpack_public_path__ + "static/media/icon_news.bd7b67b3.svg";